import { render } from "./SereneTermsAndConditionsEN.vue?vue&type=template&id=7311008e"
import script from "./SereneTermsAndConditionsEN.vue?vue&type=script&lang=js"
export * from "./SereneTermsAndConditionsEN.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__